import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import SchedulerConfigForm from './SchedulerConfigForm';
import { SchedulerConfigFormData } from '@/types/smsScheduler';

interface SchedulerCreateDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: SchedulerConfigFormData) => void;
  loading?: boolean;
  error?: string | null;
}

const SchedulerCreateDialog: React.FC<SchedulerCreateDialogProps> = ({
  open,
  onClose,
  onSubmit,
  loading = false,
  error = null
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { minHeight: '500px' }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AddIcon color="primary" />
          <Typography variant="h6" component="span">
            Create New Scheduler Configuration
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Create a new automated SMS scheduler that will send renewal notifications 
          to customers based on their policy RED (Renewal Expiry Date).
        </Typography>

        <SchedulerConfigForm
          mode="create"
          onSubmit={onSubmit}
          onCancel={onClose}
          loading={loading}
          error={error}
        />
      </DialogContent>
    </Dialog>
  );
};

export default SchedulerCreateDialog;

